export default function useCustomizerScale() {
  return useState('bigLayoutPadding', () => {
    return 120;
  });
}
